import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'rx-checkboxes',
  templateUrl: './checkboxes.component.html',
  styleUrls: ['./checkboxes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CheckboxesComponent),
    multi: true
  }]
})

export class CheckboxesComponent {

  /** Options object: {id: [int], name: [string], checked: [bool]} */
  @Input() public options: any[];

  /** Disabled state */
  @Input() disabled: boolean;

  /** Check required */
  @Input() required = false;

  /** Uncheck required */
  @Input() requiredReverse = false;

  @Input() title?: string;

  @Input() secondaryTitle?: string;

  @Input() error?: string;

  /** On checkbox selection event */
  @Output() toggle = new EventEmitter<any[]>();

  /** Touched state */
  isTouched = false;

  constructor() {
    this.disabled = false;
  }

  /** Toggle value change and emit selection value */
  onToggle() {
    this.isTouched = true;
    const selectedOption = this.options.filter( (option) => option.checked );
    this.toggle.emit(selectedOption);
  }

  public onChange = (value: any) => {/* Part of NG_VALUE_ACCESSOR implementation */ };
  public registerOnTouched = (fn: any) => {/* Part of NG_VALUE_ACCESSOR implementation */ };
  public writeValue = (value: any) => { this.onChange(value); };
  public registerOnChange = (fn: (val: any) => void) => this.onChange = fn;
}
